import React, { useState, useEffect, useContext } from 'react';
import { MyContext } from './MyContext';
import UtilizationGraph from './UtilizationGraph';
import * as showTargets from './ShowTargets';
import useInterval from './useInterval';
import useDisplayConfig from './useDisplayConfig';
import { makeStyles } from '@material-ui/core/styles';
import { colorBlue, colorGreen, colorYellow, colorRed } from './UtilizationGraph';
import Typography from '@material-ui/core/Typography';
import MonthlyComparisonChart from './MonthlyComparisonChart';
import stackedLogo from './MTlogo-stacked.png'
//import stackedLogo from './MTlogo-horiz.png'
const useStyles = makeStyles({
    square: {
        width: '35px',
        height: '35px',
        marginLeft: '10px',
        marginRight: '10px',
        opacity: '.9',
        display: 'inlineBlock',
        marginTop: '5px'
    },
    utilizationkeyrow: {
        margin: 'auto',
        width: '50%',
        display: 'flex',
        // alignItems: 'center',
        paddingLeft: '300px'
    },
    center: {
        font: 'bold 20px Georgia, serif',
        marginBottom: '10px',
        //   verticalAlign: 'top',
        textAlign: 'right',
        clear: 'both',
        float: 'left',
        height: '15px',
    },
    footer: {
        font: '55px arial, bold',
        color: '#3cb4e5',
        marginTop: '0px',
        marginLeft: '60px',
    }
});

const ShopFloorDisplay = ({ displayConfigId = null }) => {
    const classes = useStyles();
    const { setLastUpdateTime, selectedMachines, setSelectedMachines, data, customerName } = useContext(MyContext);

    useInterval(() => {
        //console.log("OperatorView useEffect customerName: " + customerName);
        setLastUpdateTime(new Date());
    }, 60000 * 5);

    useEffect(() => {
        //do this right away avoid having to wait 5mins for the display to filter to the specific 
        //dispaly
        setLastUpdateTime(new Date())
    }, []);
    useEffect(() => {
        if (data) {
            // console.log("ShopFloorDisplay customerName useEffect data changed selectedMachines: " + selectedMachines.length);
            //a customer will set machine.customersethide to have it not display so pass true for evalSetHide
            showTargets.handleSetSelectedMachinesForShopFloorDisplay(data, selectedMachines, setSelectedMachines)
        }
    }, [data]);
    useEffect(() => {
        // console.log("ShopFloorDisplay useEffect selectedMachines: " + selectedMachines.length);
    }, [selectedMachines]);

    useDisplayConfig({ displayName: displayConfigId });

    return (
        <div style={{marginTop:'10px'}}>
            <div style={{position:'relative', justifyContent:'space-around', marginLeft:'70%', marginBottom:'-100px', zIndex:'10' }}>
             <img style={{height:'80px'}} src={stackedLogo} alt="Machine Icon"/>
             </div>
             <UtilizationGraph data={data} selectedMachines={selectedMachines} isShopFloorDisplay={true} />
            <div style={{ display: 'block' }}>
                <div className={classes.utilizationkeyrow}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={classes.square} style={{ background: colorBlue }}></div><label className={classes.center}>Idle</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={classes.square} style={{ background: colorRed }}></div><label className={classes.center}>Under Perform</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={classes.square} style={{ background: colorYellow }}></div><label className={classes.center}>Performing</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={classes.square} style={{ background: colorGreen }}></div><label className={classes.center}>Exceeding</label>
                    </div>

                </div>


                <div style={{ fontSize: '24px', fontFamily: 'Arial, sans-serif', marginLeft: '200px' }}>

                    {customerName ?
                        <div>
                            <MonthlyComparisonChart apiUrl={"https://py1s8r7joc.execute-api.us-west-2.amazonaws.com/production/" + customerName + "/month_over_month.json"} />
                        </div>
                        : <div></div>}

                </div>


                {/* <div style={{ marginTop: '35px' }} className={classes.utilizationkeyrow}><h2 className={classes.footer}>MachineTracking.com</h2></div> */}
            </div>

        </div>
    );
};
export default ShopFloorDisplay;